
// 日本事务所
export default [

  /*  客户信息一览 */
  {
    path: '/menu3_japanfirm',
    name: 'menu3_japanfirm',
    component: () => import( /* webpackChunkName: "businessProcessing" */ '@/views/JapaneseOffice/businessProcessing/userInfo/index'),
    meta: {
      activeMenu: 'menu3_japanfirm', // 可用选中菜单
    }
  },

  /*  咨询记录 */
  {
    path: '/consultationRecords',
    name: 'consultationRecords',
    component: () => import( /* webpackChunkName: "businessProcessing" */ '@/views/JapaneseOffice/businessProcessing/consultationRecords/index'),
    meta: {
      activeMenu: 'consultationRecords', // 可用选中菜单
    }
  },
  /*  意见反馈 */
  {
    path: '/feedback',
    name: 'feedback',
    component: () => import( /* webpackChunkName: "businessProcessing" */ '@/views/JapaneseOffice/businessProcessing/feedback/index'),
    meta: {
      activeMenu: 'feedback', // 可用选中菜单
    }
  },


]